export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    radioBoxControl: {
        marginBottom: 20,
        '&:last-child': {
            marginBottom: 0,
        },
    },
});
